import React, { useState } from "react";
import "./Social.css";
import tourImage from "../images/tour.jpg";
import kasbahImage from "../images/kasbah.jpg";
import chellahImage from "../images/Chella.png";
import jardinImage from "../images/jardin.jpg";
import museeImage from "../images/musee.jpg";
import marinaImage from "../images/marina.jpg";
import tower from "../images/tower.avif";


function Social() {
  const [activeTab, setActiveTab] = useState("Mohammed VI Tower");

  const data = {
    "Mohammed VI Tower": {
      title: "Mohammed VI Tower",
      description: `The Mohammed VI Tower is a 55-story, 250-metre skyscraper in the city of Salé, bordering Rabat, the capital of Morocco. It is the tallest building in Morocco and the third tallest in Africa.`,
      image: tower,
    },
    "Hassan Tower": {
      title: "Hassan Tower",
      description: `This unfinished 12th-century minaret is one of the iconic symbols of Rabat. 
      It sits at the heart of a historical complex that includes the Mohammed V Mausoleum, 
      a masterpiece of traditional Moroccan architecture.`,
      image: tourImage,
    },
    "Oudayas Kasbah": {
      title: "Oudayas Kasbah",
      description: `Perched on a hill overlooking the Atlantic Ocean and the mouth of the Bouregreg River, 
      this ancient fortress offers picturesque alleys, Andalusian gardens, and an impressive panoramic view.`,
      image: kasbahImage,
    },
    "Chellah": {
      title: "Chellah",
      description: `This fascinating archaeological site houses Roman and Islamic ruins surrounded by lush gardens. 
      It is an ideal place to dive into the history of Rabat.`,
      image: chellahImage,
    },
    "Botanical Gardens": {
      title: "Botanical Test Gardens",
      description: `Created in 1914, this garden is a haven of peace that houses a wide variety of plants and trees, perfect for nature lovers.`,
      image: jardinImage,
    },
    "Mohammed VI Museum": {
      title: "Mohammed VI Museum of Modern and Contemporary Art",
      description: `Morocco's first museum of modern art, it exhibits works by both Moroccan and international artists.`,
      image: museeImage,
    },
    "Marina": {
      title: "Bouregreg Marina",
      description: `This modern area along the Bouregreg River offers breathtaking views of Salé and the Oudayas Kasbah, along with restaurants and water activities.`,
      image: marinaImage,
    },
  };

  return (
    <div className="social-section">
      <div className="social-header">
        <h1 className="social-title">About Rabat</h1>
        <p className="social-intro">
          Discover the cultural and historical wealth of Rabat, the imperial capital of Morocco, where tradition meets modernity.
        </p>
      </div>

      <div className="social-nav">
        {Object.keys(data).map((key) => (
          <div
            key={key}
            className={`nav-item ${activeTab === key ? "active" : ""}`}
            onClick={() => setActiveTab(key)}
          >
            {key}
          </div>
        ))}
      </div>

      <div className="social-content">
        <div className="social-image">
          <img src={data[activeTab].image} alt={data[activeTab].title} />
        </div>
        <div className="social-description">
          <h2>{data[activeTab].title}</h2>
          <p>{data[activeTab].description}</p>
        </div>
      </div>
      
      <div className="social-spacer"></div>
        
      <h2 className="social-subtitle">Useful Links</h2>
      <div className="link-cards">
        <a href="https://www.visitmorocco.com/en/travel/rabat" target="_blank" rel="noopener noreferrer" className="link-card">
          <i className="fas fa-map-marker-alt"></i>
          <span>Regional Tourism Council</span>
        </a>
        <a href="https://www.visitrabat.com/offres/cultural-rabat/" target="_blank" rel="noopener noreferrer" className="link-card">
          <i className="fas fa-landmark"></i>
          <span>Cultural Rabat</span>
        </a>
        <a href="http://www.museemohammed6.ma/" target="_blank" rel="noopener noreferrer" className="link-card">
          <i className="fas fa-paint-brush"></i>
          <span>Mohammed VI Museum</span>
        </a>
      </div>
    </div>
  );
}

export default Social;